import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import * as actions from 'store/modules/profileDetails/actions';
import AlertMessage from 'components/AlertMessage';
import CheckboxCustom from 'components/CheckboxCustom';
import ChangeEmailModal from 'components/ChangeEmailModal';
import ChangePasswordModal from 'components/ChangePasswordModal';

import profileEdit from 'images/pencil-icon.svg';

import classnames from 'classnames';

class ProfileDetails extends Component {
  state = {
    isOpen: false,
    showAlertSuccess: false,
    showAlertError: false,
    alertTextSuccess: '',
    alertTextError: '',
  };

  componentDidMount() {
    const { showUserAction } = this.props;
    showUserAction();
  }

  handleEdit = async values => {
    const { updateEmailAction } = this.props;
    const body = {
      user: {
        email: values.email,
      },
    };
    const response = await updateEmailAction(body);
    if (response.status === 200) {
      this.setState({ isEdit: false });
    }
  };

  handleUpdatePassword = async (values, setSubmitting, setErrors) => {
    const { updatePasswordAction } = this.props;
    const body = {
      user: {
        current_password: values.currentPassword,
        password: values.newPassword,
        password_confirmation: values.newPassword,
      },
    };
    const response = await updatePasswordAction(body, setSubmitting, setErrors);
    setSubmitting(false);
    if (response.status === 200) {
      this.setState({ showAlertSuccess: true });
      this.setState({
        alertTextSuccess: 'Password has been changed!',
      });
      setTimeout(() => {
        this.setState({ showAlertSuccess: false });
      }, 4000);
    } else {
      this.setState({ showAlertError: true });
      this.setState({
        alertTextError: "Can't perform change. Check errors below",
      });
      setTimeout(() => {
        this.setState({ showAlertError: false });
      }, 4000);
    }
    return response;
  };

  handleUpdateEmail = async (values, setSubmitting, setErrors) => {
    const { updateEmailAction } = this.props;
    const body = {
      user: {
        email: values.newEmail,
      },
    };
    const response = await updateEmailAction(body, setSubmitting, setErrors);
    setSubmitting(false);
    if (response.status === 200) {
      this.setState({ showAlertSuccess: true });
      this.setState({
        alertTextSuccess: 'Email updated! \nCheck your email to confirm change',
      });
      setTimeout(() => {
        this.setState({ showAlertSuccess: false });
      }, 4000);
      this.showModal();
    } else {
      this.setState({ showAlertError: true });
      this.setState({
        alertTextError: response.error,
      });
      setTimeout(() => {
        this.setState({ showAlertError: false });
      }, 4000);
    }
    return response;
  };

  hadleUpdateReceive = async value => {
    const { updateReceivesAction } = this.props;
    const body = {
      receive_emails: value,
    };
    await updateReceivesAction(body);
  };

  renderEditButton = () => {
    return (
      <div className="profile__edit">
        <button className="btn-control btn-edit" onClick={this.showModal}>
          <img src={profileEdit} alt="" />
        </button>
      </div>
    );
  };

  showModal = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };

  resendEmail = async () => {
    const { sendEmailConfirmation } = this.props;
    const response = await sendEmailConfirmation();
    if (response.status === 200) {
      this.setState({ showAlertSuccess: true });
      this.setState({
        alertTextSuccess:
          'Email confirmation sent! \nCheck your email to confirm.',
      });
      setTimeout(() => {
        this.setState({ showAlertSuccess: false });
      }, 4000);
    } else {
      this.setState({ showAlertError: true });
      this.setState({
        alertTextError: response.error,
      });
      setTimeout(() => {
        this.setState({ showAlertError: false });
      }, 4000);
    }
  };

  render() {
    const {
      isOpen,
      showAlertSuccess,
      showAlertError,
      alertTextSuccess,
      alertTextError,
    } = this.state;
    const { email, receive_emails, confirmed } = this.props.details;
    return (
      <Fragment>
        {showAlertSuccess && <AlertMessage text={alertTextSuccess} />}
        {showAlertError && (
          <AlertMessage
            classAlert={classnames({
              error: true,
            })}
            text={alertTextError}
          />
        )}
        <h2 className="h2-title">Profile details</h2>
        <div className="separator-line" />
        <div className="profile__inner bg">
          <div className="profile__row">
            <div className="std-text">Email</div>
            <div className="std-text bold">{email}</div>
            {!confirmed && (
              <div className="std-text">
                Your email isn't confirmed!{' '}
                <span
                  className="std-text blue bold pointer"
                  onClick={this.resendEmail}>
                  {' '}
                  Resend verification link
                </span>
              </div>
            )}
            <div className="separator-line" />
            {this.renderEditButton()}
          </div>
          <div className="profile__row">
            <div className="std-text">Email updates</div>
            <CheckboxCustom
              labelText="Yes, I'd like to receive occasional email updates about InstaLinks"
              onChange={e => this.hadleUpdateReceive(e.target.checked)}
              checked={receive_emails}
            />
          </div>
        </div>
        <ChangeEmailModal
          isOpen={isOpen}
          toggle={this.showModal}
          handleSubmit={this.handleUpdateEmail}
        />
        <div className="profile__inner bg m-b-50">
          <div className="std-text bold blue">
            <ChangePasswordModal updatePassword={this.handleUpdatePassword} />
          </div>
        </div>
      </Fragment>
    );
  }
}

function mapStateProps(state) {
  return {
    details: state.details.user,
  };
}
export default connect(
  mapStateProps,
  actions,
)(ProfileDetails);



// WEBPACK FOOTER //
// ./src/scenes/Profile/ProfileDetails.js